(function ($) {
  // Catch any ajax error caused by session timeout and reload page, otherwise let caller handle error
  // This is generally caused by tab changes after a session has timed out
  $(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
    if (jqXHR && jqXHR.status === 401) {
      window.location.reload()
    }
  })
})(jQuery)
